module.exports = __webpack_public_path__ + "img/unis_logo.9a8ed12d.png";